import React from 'react'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import EmptyListUI from '../../widgets/output/EmptyListUI'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import BudgetItemListUI from '../../components/finapp/budget/BudgetItemListUI'
import BudgetHeaderUI from '../../components/finapp/budget/BudgetHeaderUI'
import './BudgetDetailPage.css'

const BudgetDetailPageUI = ({context, messageList, errorList, order, budget, itemList, filteredItemList,
    searchFilter, onRefreshClick, onSearchFilterChange,
    requestFundMode, onRequestFundClick, onRequestFundCancel, onRequestFundComplete,
    onUpdateBudgetClick, onCancelUpdateBudget, onUpdateBudgetComplete, updateBudgetMode
  }) =>
  <PrivatePageSF context={context} className='pg_budget'
    backLink={`/orders/${order!==null?order.customerOrderId:''}/budgets`}
    messageList={messageList} headerMessageKey='c_budget'
    centered={(!order || !budget || !itemList) && !errorList}
  >
    {
      (!order || !budget || !itemList) && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      order && budget && itemList &&
      <React.Fragment>
        <PageTitleUI context={context} goBack={true} backLink={`/orders/${order.customerOrderId}/budgets`}
          messageList={messageList} titleMessageKey='c_budget'
        />
        <BudgetHeaderUI context={context} messageList={messageList} order={order} budget={budget}
          requestFundMode={requestFundMode} onRequestFundClick={onRequestFundClick}
          onRequestFundCancel={onRequestFundCancel} onRequestFundComplete={onRequestFundComplete}
          onUpdateClick={onUpdateBudgetClick} updateMode={updateBudgetMode} onCancelClick={onCancelUpdateBudget}
          onUpdateComplete={onUpdateBudgetComplete}
        />
      </React.Fragment>
    }
    {
      itemList && itemList.length === 0 &&
      <EmptyListUI
        context={context}
        messageList={messageList}
        createEnabled={context.permissions && context.permissions.includes('acc_manage')}
        createLink='/orders/create'
        createLinkKey='c_add_bdg_item'
        createDisabledMessageKey='c_no_item_msg'
      />
    }
    {
      order && budget && itemList && filteredItemList && itemList.length !== 0 &&
      <BudgetItemListUI
        context={context}
        itemList={filteredItemList}
        messageList={messageList}
        searchFilter={searchFilter}
        // events
        onRefreshClick={onRefreshClick}
        onSearchFilterChange={onSearchFilterChange}
      />
    }
  </PrivatePageSF>

export default BudgetDetailPageUI
